import React from 'react';

import { EmailSuggestion } from '../types';

import SuggestionItem from './SuggestionItem';

type SuggestionsDropdownProps = {
  suggestions: EmailSuggestion[];
  selectedIndex: number;
  onSelect: (email: string) => void;
};

const SuggestionsDropdown: React.FC<SuggestionsDropdownProps> = ({
  suggestions,
  selectedIndex,
  onSelect,
}) => {
  if (suggestions.length === 0) {
    return null;
  }

  return (
    <div className="absolute z-10 w-full mt-1 max-h-60 overflow-y-auto rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800">
      {suggestions.map((suggestion, index) => (
        <SuggestionItem
          isSelected={index === selectedIndex}
          key={suggestion.email}
          onSelect={onSelect}
          suggestion={suggestion} />
      ))}
    </div>
  );
};

export default SuggestionsDropdown;
